import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Order Details',
  basePath: '/order-details',
  columns: [
    { key: 'book_id', label: 'Book ID', sortable: true },
    { key: 'order_id', label: 'Order ID', sortable: true },
    { key: 'book_title', label: 'Book Title', sortable: true },
    { key: 'book_price', label: 'Book Price', sortable: true },
    { key: 'book_vat', label: 'Book VAT', sortable: true },
    { key: 'book_kind', label: 'Book Kind', sortable: true },
    { key: 'book_count', label: 'Book Count', sortable: true },
  ],
  fields: [
    { key: 'book_id', label: 'Book ID', type: 'text' },
    { key: 'order_id', label: 'Order ID', type: 'text' },
    { key: 'book_title', label: 'Book Title', type: 'text' },
    { key: 'book_price', label: 'Book Price', type: 'number' },
    { key: 'book_vat', label: 'Book VAT', type: 'number' },
    { key: 'book_kind', label: 'Book Kind', type: 'text' },
    { key: 'book_count', label: 'Book Count', type: 'number' },
  ],
  defaultSort: { field: 'order_id', dir: 'asc' },
});
